import { Grid, Typography } from "@mui/material";
import { useMemo, useState } from "react";

import AdvancedTradeInputs from "./AdvancedTradeInputs";
import { BadgeShape } from "./AdvancedTradeInputs/TradeInput";
import { TRADE_SIDE } from "pages/BasicTrade/components/constants";
import TradeTypeTabs from "./TradeTypeTabs";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

function AdvancedTradeForm({ handleGetWalletInfo }) {
  const { source } = useParams();
  const tradeInsertForm = useSelector((state) => state.trade.tradeInsertForm?.data);

  const [advancedTradeInputKey, setAdvancedTradeInputKey] = useState(1)

  const sourceCoin = useMemo(() => {
    return tradeInsertForm?.lisCoinPair?.find((coin) => coin?.id === +source);
  }, [source, tradeInsertForm?.lisCoinPair]);

  return (
    <Grid container mt={2} p={1} spacing={1}>
      <TradeTypeTabs />

      <Grid item xs={12}>
        {sourceCoin?.extraUnitComment && (
          <Grid item xs={12}>
            <BadgeShape>
              <Typography
                textAlign="center"
                variant="subtitle1"
                fontWeight={500}
                color="text.main"
              >
                {sourceCoin?.extraUnitComment}
              </Typography>
            </BadgeShape>
          </Grid>
        )}
      </Grid>

      <Grid item xs={6}>
        <AdvancedTradeInputs
          key={`form-buy-${advancedTradeInputKey}`}
          sideId={TRADE_SIDE.Buy.id}
          handleGetWalletInfo={handleGetWalletInfo}
          setAdvancedTradeInputKey={setAdvancedTradeInputKey}
        />
      </Grid>

      <Grid item xs={6}>
        <AdvancedTradeInputs
          key={`form-sell-${advancedTradeInputKey}`}
          sideId={TRADE_SIDE.Sell.id}
          handleGetWalletInfo={handleGetWalletInfo}
          setAdvancedTradeInputKey={setAdvancedTradeInputKey}
        />
      </Grid>
    </Grid>
  );
}

export default AdvancedTradeForm;
